<script setup>
import BackButtonComponent from "@/components/utils/BackButtonComponent.vue";
import { ref } from "vue";
import LoadingComponent from "@/components/utils/LoadingComponent.vue";
import {createDriver} from "@/services/userService";
import { customToast } from "@/globals/utils/customToast";
import DefaultButton from "@/components/utils/DefaultButton.vue";

const user = ref({
  name: "",
  email: "",
  phone: "",
  role: "user",
  status: "available",
  password: "",
  rating: 5,
});

const error = ref(null);

// Crear usuario
const _createUser = async () => {
  try {
    await createDriver(user.value);
    customToast("User created successfully.", "success");

    // Resetear el formulario después de crear
    user.value = {
      name: "",
      email: "",
      phone: "",
      role: "driver",
      status: "available",
      password: "",
      rating: 5,
    };
  } catch (err) {
    error.value = "Error creating the user.";
    customToast("Error creating the user.", "error");
  }
};
</script>

<template>
  <div class="flex justify-center items-start bg-gray-100 dark:bg-gray-800 px-4 py-8">
    <div class="w-full max-w-[1800px] p-8 bg-white dark:bg-gray-900 rounded shadow-lg">
      <BackButtonComponent url="/users" class="mb-2" />
      <LoadingComponent v-if="!user" />
      <div v-else>
        <h1 class="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-6 text-center">Create Driver</h1>
        <form @submit.prevent="_createUser" class="space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Status -->
            <div>
              <label for="status" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Status</label>
              <select
                  id="status"
                  v-model="user.status"
                  class="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-gray-300 focus:outline-none focus:ring-emerald-500 dark:focus:ring-emerald-700"
                  required
              >
                <option value="available">Available</option>
                <option value="unavailable">Unavailable</option>
              </select>
            </div>

            <!-- Name -->
            <div>
              <label for="name" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Name</label>
              <input
                  type="text"
                  id="name"
                  v-model="user.name"
                  class="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-gray-300 focus:outline-none focus:ring-emerald-500 dark:focus:ring-emerald-700"
                  required
              />
            </div>

            <!-- Email -->
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
              <input
                  type="email"
                  id="email"
                  v-model="user.email"
                  class="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-gray-300 focus:outline-none focus:ring-emerald-500 dark:focus:ring-emerald-700"
                  required
              />
            </div>

            <!-- Phone -->
            <div>
              <label for="phone" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Phone</label>
              <input
                  type="tel"
                  id="phone"
                  v-model="user.phone"
                  pattern="^\+?[0-9\- ]{7,15}$"
                  class="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-gray-300 focus:outline-none focus:ring-emerald-500 dark:focus:ring-emerald-700"
                  required
              />
            </div>

            <!-- Password -->
            <div>
              <label for="password" class="block text-sm font-medium text-gray-700 dark:text-gray-300">Password</label>
              <input
                  type="password"
                  id="password"
                  v-model="user.password"
                  class="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-gray-300 focus:outline-none focus:ring-emerald-500 dark:focus:ring-emerald-700"
                  required
              />
            </div>

          </div>
          <!-- Submit Button -->
          <div class="text-center mt-6">
            <DefaultButton title="Create" type="submit" />
          </div>
        </form>
        <div v-if="error" class="mt-4 text-center text-red-500">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Optional additional styles */
</style>
